import * as React from 'react';

import {
  IconRegularChevronLeft,
  IconRegularChevronRight,
  IBasicStyledProps,
  SemanticColorKey,
} from '@notino/react-styleguide';

import { ArrowWrapper } from './styled';

interface IArrowProps extends IBasicStyledProps {
  direction: string;
  color?: SemanticColorKey;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  size?: string;
  offset?: string;
}

export const Arrow: React.FC<IArrowProps> = ({
  direction,
  onClick,
  color: customColor,
  size: _size,
  offset,
  ...basicStyledProps
}) => {
  const color = customColor || (onClick ? 'icon.secondary' : 'icon.disabled');
  const isLeft = direction === 'left';
  const size = _size ?? '24px';
  return (
    <ArrowWrapper
      onClick={onClick}
      isLeft={isLeft}
      {...basicStyledProps}
      offset={offset}
    >
      {isLeft ? (
        <IconRegularChevronLeft color={color} width={size} height={size} />
      ) : (
        <IconRegularChevronRight color={color} width={size} height={size} />
      )}
    </ArrowWrapper>
  );
};
